"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What technologies do you specialize in?",
  answer: "Our team is proficient in full-stack web development, mobile applications, and cloud infrastructure. We leverage cutting-edge frameworks like React, Node.js, and AWS to build scalable, performant architectures tailored to your specific business requirements."
}, {
  question: "Do you work with early-stage startups?",
  answer: "Absolutely. We specialize in helping innovative founders translate complex ideas into elegant MVPs. Our consultancy approach focuses on building a solid technical foundation that can scale as your user base and business goals grow."
}, {
  question: "How do you ensure the security of our data?",
  answer: "Security is integrated into our development lifecycle from day one. We implement industry-standard encryption, secure cloud configurations, and rigorous testing protocols to protect your intellectual property and user data against modern threats."
}, {
  question: "What is the process for starting a new project?",
  answer: "The journey begins with a technical discovery session. We dive deep into your requirements, define the project scope, and map out a strategic roadmap. Once the architecture is finalized, our engineers begin the 'forge' process to bring your vision to life."
}];
export default function CommonQuestions() {
  return;
}